<template>
  <div>
    <el-row v-if="itemData.status === 'cgAccepted'">
      <el-col :span="1.5">
        <el-button class="accept-button" size="medium" type="primary" :disabled="fake" style="margin-right: 8px; padding: 0px !important;" @click.native.prevent="acceptButtonClick">
          <img src="https://storage.healthathome.in.th/ad50c75c-fe4b-4019-a3d7-923d7be4a759.svg" alt="">
          <span style="margin-left: 8px;">เลือกผู้ดูแล</span>
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button class="match-reject-button" size="medium" type="danger" style="padding: 0px !important;" :disabled="fake" @click.native.prevent="rejectButtonClick">
          <img src="https://storage.healthathome.in.th/639d6705-dab2-49d1-9b52-2413d1a55164.svg" alt="">
          <span style="margin-left: 8px;">ปฏิเสธผู้ดูแล</span>
        </el-button>

      </el-col>
    </el-row>
    <el-row v-else-if="itemData.status === 'cgRejected'" style="padding: 0px !important;">
      <el-button class="cg-reject" size="medium" type="danger" disabled>
        <img src="https://storage.healthathome.in.th/64c481b4-8d4c-4626-93ae-69a0106d01e3.svg" alt="">
        <span style="margin-left: 8px;">ผู้ดูแลปฏิเสธ</span>
        </el-button>
    </el-row>
    <el-row v-else-if="itemData.status === 'seen'">
      <el-button class="noaction" size="medium" disabled>
        <img src="https://storage.healthathome.in.th/834e4630-a7b7-40b5-b3d2-230a6435c659.svg" alt="">
        <span style="margin-left: 8px;">อ่านแล้ว</span>
      </el-button>
    </el-row>
    <el-row v-else-if="itemData.status === 'unmatched'">
      <el-button class="unmatched" size="medium" disabled>
        <img src="https://storage.healthathome.in.th/64c481b4-8d4c-4626-93ae-69a0106d01e3.svg" alt="">
        <span style="margin-left: 8px;">แอดมินปฏิเสธ</span>
      </el-button>
    </el-row>
    <el-row v-else-if="itemData.status === 'pinned'">
      <el-button class="pinned" size="medium" disabled>
        <img src="https://storage.healthathome.in.th/57638422-6bd6-44b8-abfc-13571bdfbffc.svg" alt="">
        <span style="margin-left: 8px;">ปักหมุด</span>
      </el-button>
    </el-row>
  </div>
</template>

<style lang="scss">
  .el-button span {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>

<style lang="scss" scoped>
  .accept-button {
    height: 32px;
    width: 107px;
    padding: 10px 4px !important;
    font-size: 12px;
  }

  .match-reject-button {
    height: 32px;
    width: 107px !important;
    padding: 10px 4px !important;
    font-size: 12px;
  }

  .noaction {
    background-color: white;
    color: #c0c4cc;
    border: 1.5px solid #c0c4cc !important;
    font-size: 12px;
    width: 107px;
    height: 32px;
    padding: 6px 4px !important;
    pointer-events: none;
  }

  .cg-reject, .unmatched {
    background-color: white;
    color: #FF577F;
    border: 1.5px solid #FF577F !important;
    font-size: 12px;
    width: 107px;
    height: 32px;
    padding: 8px 4px !important;
    pointer-events: none;
  }

  .pinned {
    background-color: white;
    color: #5489FF;
    border: 1.5px solid #5489FF !important;
    font-size: 12px;
    width: 107px;
    height: 32px;
    padding: 8px 4px !important;
    pointer-events: none;
  }
</style>

<script>
export default {
  name: 'MatchingDirectActionPanel',
  props: {
    itemData: {
      type: Object,
      required: true,
    },
    itemIndex: {
      type: Number,
      required: true,
    },
    fake: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    acceptButtonClick () {
      this.$emit('acceptButtonClick', this.itemIndex, this.itemData)
    },
    rejectButtonClick () {
      this.$emit('rejectButtonClick', this.itemIndex, this.itemData)
    },
  },
}
</script>
